import { NotFound } from "../views/notFound";
import PrivateRoute from "./PrivateRoute";
import React from "react";

export const NotFoundRoute = () => {
    return <PrivateRoute path="*" exact={true}
                         permission={null}
                         component={NotFound}/>;
};